import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyGetAllProjectSynergyStatusByTypeIdQuery, useLazyGetAllSynergyPriorityQuery, useLazyGetAllSynergyTypesQuery, useUpdateProjectSynergyMutation } from '../../../../../../app/services/projectSynergyAPI';
import { useLazyGetAllProjectsQuery } from '../../../../../../app/services/projectManagementAPI';
import { useGetAllProjectTeamListMutation } from '../../../../../../app/services/projectTeamManagementAPI';
import Buttons from '../../../../../../components/ui/button/Buttons';
import FormCreator from '../../../../../../components/finalForms/FormCreator';
import { mapDropdownOptions } from '../../../../../../components/finalForms/libs/mapDropdownOptions';
import { decryptUrlData } from '../../../../../../services/CryptoService';
import CardSection from '../../../../../../components/ui/card/CardSection';
import ToastService from '../../../../../../services/toastService/ToastService';
import { useLazyGetProjectModuleByProjectIdQuery } from '../../../../../../app/services/projectModuleAPI';
import { EditSynergyDescriptionData } from './EditSynergy.Data';
import SwalAlert from '../../../../../../services/swalService/SwalService';

/** RTK Query */
const EditSynergyDescription = ({ editsynergy, closePopup, synergyId }) => {

  const SynergyRef = useRef();
  let IncludeUserStory;
  let IncludeChangeRequest;

  const { id } = useParams();
  let projectId = null;
  const { confirmWithTextarea } = SwalAlert();

  const projectIdData = id ? decryptUrlData(id) : 0;
  if (typeof projectIdData === 'object' && projectIdData !== null) {

    projectId = projectIdData.projectId;
  } else if (projectIdData) {

    projectId = projectIdData;
  }

  const [shouldFormCretoerRerender, setShouldFormCretoerRerender] = useState(false);
  const [synergyform, setsynergyform] = useState(EditSynergyDescriptionData);

  const [getProjectModuleByProjectId, {
    isFetching: isgetProjectModuleByProjectIdfetching,
    isSuccess: isgetProjectModuleByProjectIdsuccess,
    data: isgetProjectModuleByProjectIdData,
  },] = useLazyGetProjectModuleByProjectIdQuery();

  const [getAllSynergyTypes, {
    isFetching: isAllSynergyTypesFetching,
    isSuccess: isAllSynergyTypesSuccess,
    data: AllSynergyTypesData
  },] = useLazyGetAllSynergyTypesQuery();

  const [getAllSynergyPriority, {
    isFetching: isAllSynergyPriorityFetching,
    isSuccess: isAllSynergyPrioritySuccess,
    data: AllSynergyPriorityData
  },] = useLazyGetAllSynergyPriorityQuery();

  const [getAllProjects, {
    isFetching: isProjectFetching,
    isSuccess: isProjectFetched,
    data: allProjectData
  },] = useLazyGetAllProjectsQuery();


  const [getAllProjectSynergyStatusByTypeId, {
    isFetching: isStatusFetching,
    isSuccess: isStatusFetched,
    data: allStatusData
  },] = useLazyGetAllProjectSynergyStatusByTypeIdQuery();

  const [getAssignedUserList, {
    isFetching: isAssignedUserNameFetching,
    isSuccess: isAssignedUserName,
    data: assignedUserNameData,
  },] = useGetAllProjectTeamListMutation();

  const [updateProjectSynergy, {
    isFetching: isupdateProjectSynergyFetching,
    isSuccess: isupdateProjectSynergySuccess,
    data: updateProjectSynergyData
  },] = useUpdateProjectSynergyMutation();

  useEffect(() => {
    getProjectModuleByProjectId(projectId);
    getAllSynergyTypes();
    getAllSynergyPriority();
    getAllProjects();
    if(editsynergy.synergyTypeID === 2 ){
      // eslint-disable-next-line react-hooks/exhaustive-deps
      IncludeChangeRequest = true;
      // eslint-disable-next-line react-hooks/exhaustive-deps
      IncludeUserStory=false;
    }
    else{
      IncludeChangeRequest = false;
      IncludeUserStory=true;
    }
    getAllProjectSynergyStatusByTypeId({IncludeChangeRequest:IncludeChangeRequest,IncludeUserStory:IncludeUserStory})
  }, [])

  useEffect(() => {
    if (projectId) {
      const request = {
        pagination: {
          pageNumber: 1,
          pageSize: 40,
        },
        projectId: projectId,
      }
      getAssignedUserList(request)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId])

  useEffect(() => {
    if (!isAssignedUserNameFetching && isAssignedUserName && assignedUserNameData) {
      const userNameList = assignedUserNameData.dataSource.map((item) => ({
        value: item.userId,
        label: item.userName,
      }));
      mapDropdownOptions(
        EditSynergyDescriptionData,
        'ProjectSynergy',
        'reportedBy',
        userNameList,
        'value',
        'label',
      );
    }
  }, [isAssignedUserName, isAssignedUserNameFetching, assignedUserNameData]);

  useEffect(() => {
    if (!isProjectFetching && isProjectFetched && allProjectData) {
      mapDropdownOptions(
        EditSynergyDescriptionData,
        'ProjectSynergy',
        'projectId',
        allProjectData,
        'projectId',
        'projectName',
      );
    }
    setShouldFormCretoerRerender(prevState => !prevState);
  }, [isProjectFetched, isProjectFetching, allProjectData]);

  useEffect(() => {
    if (!isAllSynergyTypesFetching && isAllSynergyTypesSuccess && AllSynergyTypesData) {
      mapDropdownOptions(
        EditSynergyDescriptionData,
        'ProjectSynergy',
        'synergyTypeID',
        AllSynergyTypesData,
        'synergyTypeID',
        'synergyTypeName',
      );
    }
    setShouldFormCretoerRerender(prevState => !prevState);
  }, [isAllSynergyTypesSuccess, isAllSynergyTypesFetching, AllSynergyTypesData]);

  useEffect(() => {
    if (!isAllSynergyPriorityFetching && isAllSynergyPrioritySuccess && AllSynergyPriorityData) {
      mapDropdownOptions(
        EditSynergyDescriptionData,
        'ProjectSynergy',
        'priorityId',
        AllSynergyPriorityData,
        'priorityId',
        'priorityName',
      );
    }
  }, [isAllSynergyPrioritySuccess, isAllSynergyPriorityFetching, AllSynergyPriorityData]);

  // useEffect(() => {
  //   if (!isgetAllSynergyStatusesFetching && isgetAllSynergyStatusesSuccess && getAllSynergyStatusesData) {
  //     mapDropdownOptions(
  //       EditSynergyDescriptionData,
  //       'ProjectSynergy',
  //       'status',
  //       getAllSynergyStatusesData,
  //       'statusID',
  //       'statusName',
  //     );
  //   }
  //   setShouldFormCretoerRerender(prevState => !prevState);
  // }, [isgetAllSynergyStatusesSuccess, isgetAllSynergyStatusesFetching, getAllSynergyStatusesData]);

  useEffect(() => {
    if (!isStatusFetching && isStatusFetched && allStatusData) {
      mapDropdownOptions(
        EditSynergyDescriptionData,
        'ProjectSynergy',
        'status',
        allStatusData,
        'statusID',
        'statusName',
      );
    }
    setShouldFormCretoerRerender(prevState => !prevState);
  }, [isStatusFetched, isStatusFetching, allStatusData]);

  useEffect(() => {
    if (!isgetProjectModuleByProjectIdfetching && isgetProjectModuleByProjectIdsuccess && isgetProjectModuleByProjectIdData) {
      mapDropdownOptions(
        EditSynergyDescriptionData,
        'ProjectSynergy1',
        'affectedId',
        isgetProjectModuleByProjectIdData,
        'projectModuleId',
        'projectModule',
      );
    }
  }, [isgetProjectModuleByProjectIdfetching, isgetProjectModuleByProjectIdsuccess, isgetProjectModuleByProjectIdData]);


  useEffect(() => {
    if (editsynergy) {
      const selectedSynergyType = editsynergy.synergyTypeID;

      let formData = { ...EditSynergyDescriptionData };
      formData.initialState = {
        ...EditSynergyDescriptionData.initialState,
        projectId: editsynergy.projectId,
        synergyTypeID: editsynergy.synergyTypeID,
        title: editsynergy.title,
        priorityId: editsynergy.priorityID,
        reportedBy: editsynergy.reportedBy,
        description: editsynergy.description,
        projectModules: editsynergy.projectModules,
        benefit: editsynergy.benefit,
        status: editsynergy.status,
        IsAnalysisDocument: false,
        affectedId: editsynergy.projectModuleIDs
          ? editsynergy.projectModuleIDs.split(",").map(Number)
          : [],
        businessValue: editsynergy.businessValue,
        considerations: editsynergy.considerations,
        expectedOutcomes: editsynergy.expectedOutcomes,
        acceptanceCriteria: editsynergy.acceptanceCriteria,
        proposedBy: editsynergy.proposedBy,
        reasonForChange: editsynergy.reasonForChange,
        submittedDate: editsynergy.submittedDate,
        // eslint-disable-next-line no-dupe-keys
        submittedDate: editsynergy.submittedDate
          ? new Date(editsynergy.submittedDate)
          : null,
        userGoal: editsynergy.userGoal,
        userStoryID: editsynergy.userStoryID,
      }
      formData.section = EditSynergyDescriptionData.section.filter(
        (sec) =>
          sec.sectionId === "ProjectSynergy" ||
          (selectedSynergyType === 1 && sec.sectionId === "ProjectSynergy3") ||
          (selectedSynergyType === 2 && sec.sectionId === "ProjectSynergy1") ||
          (selectedSynergyType === 3 && sec.sectionId === "ProjectSynergy2")
      )
      setsynergyform(formData);
    }
  }, [editsynergy])


  const handleFieldChange = (dataField, updatedFormData) => {
    const { projectId } = updatedFormData;
    const getValue = (field) => (field && typeof field === "object" ? field.value : field);
    if (dataField === "projectId") {
      const selectedProjectId = getValue(projectId) || projectId;
      setsynergyform((prevForm) => ({
        ...prevForm,
        initialState: {
          ...prevForm.initialState,
          reportedBy: null,
          projectId: selectedProjectId
        }
      }));
      if (selectedProjectId) {
        const request = {
          pagination: {
            pageNumber: 1,
            pageSize: 40,
          },
          projectId: selectedProjectId,
        }
        getAssignedUserList(request)
      }
    }
  };

  const handleSubmit = () => {
    if (SynergyRef.current?.getFormData) {
      const formData = SynergyRef.current.getFormData();
      if (formData) {
         if(formData.status.value === 4){
          confirmWithTextarea("Confirm Reject synergy?", "", "Please enter Reason to Reject synergy", "Reason is required", "Reject", "Cancel")
          .then(({ inputText, isConfirmed }) => {
            if (isConfirmed && inputText) {
             const request = {
              synergyID: synergyId,
              projectId: formData.projectId && typeof formData.projectId === 'object' ? formData.projectId.value : formData.projectId,
              synergyTypeID: formData.synergyTypeID && typeof formData.synergyTypeID === 'object' ? formData.synergyTypeID.value : formData.synergyTypeID,
              title: formData.title,
              priorityId: formData.priorityId && typeof formData.priorityId === 'object' ? formData.priorityId.value : formData.priorityId,
              reportedBy: formData.reportedBy && typeof formData.reportedBy === 'object' ? formData.reportedBy.value : formData.reportedBy,
              description: formData.description,
              benefit: formData.benefit,
              status: formData.status && typeof formData.status === 'object' ? formData.status.value : formData.status,
              rejectedReason: inputText,
              moduleIds: formData.affectedId ? formData.affectedId.join(",") : null,
              businessValue: formData.businessValue,
              considerations: formData.considerations,
              expectedOutcomes: formData.expectedOutcomes,
              proposedBy: formData.proposedBy,
              reasonForChange: formData.reasonForChange,
              submittedDate: formData.submittedDate ? formData.submittedDate : new Date(),
              acceptanceCriteria: formData.acceptanceCriteria,
              userGoal: formData.userGoal,
            }
            updateProjectSynergy(request);
         }})  
        }
        else {
          const request = {
            synergyID: synergyId,
            projectId: formData.projectId && typeof formData.projectId === 'object' ? formData.projectId.value : formData.projectId,
            synergyTypeID: formData.synergyTypeID && typeof formData.synergyTypeID === 'object' ? formData.synergyTypeID.value : formData.synergyTypeID,
            title: formData.title,
            priorityId: formData.priorityId && typeof formData.priorityId === 'object' ? formData.priorityId.value : formData.priorityId,
            reportedBy: formData.reportedBy && typeof formData.reportedBy === 'object' ? formData.reportedBy.value : formData.reportedBy,
            description: formData.description,
            benefit: formData.benefit,
            status: formData.status && typeof formData.status === 'object' ? formData.status.value : formData.status,
            rejectedReason:null,
            moduleIds: formData.affectedId ? formData.affectedId.join(",") : null,
            businessValue: formData.businessValue,
            considerations: formData.considerations,
            expectedOutcomes: formData.expectedOutcomes,
            proposedBy: formData.proposedBy,
            reasonForChange: formData.reasonForChange,
            submittedDate: formData.submittedDate ? formData.submittedDate : new Date(),
            acceptanceCriteria: formData.acceptanceCriteria,
            userGoal: formData.userGoal,
          }
          updateProjectSynergy(request);
        }
      }
    }
  };

  useEffect(() => {
    if (isupdateProjectSynergySuccess && updateProjectSynergyData) {
      ToastService.success(updateProjectSynergyData.errorMessage);
      closePopup();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isupdateProjectSynergySuccess, updateProjectSynergyData]);

  return (
    <div className="main-page-scroll add-edit-userpage edit-synergy-sidebar">
      <div className="center-top-space">
        <CardSection
          isContentLoading={isAllSynergyPriorityFetching || isAllSynergyTypesFetching || isgetProjectModuleByProjectIdfetching || isupdateProjectSynergyFetching} >
          <div className="row">
            <FormCreator
              key={shouldFormCretoerRerender}
              ref={SynergyRef}
              config={synergyform}
              onColumnChange={handleFieldChange}
            />

          </div>
          <div className="d-flex justify-content-end mt-2 right-align">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={closePopup}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn  ml-4"
              buttonText={"Update"}
              onClick={handleSubmit}
            //  isLoading={isUserAdding || isUserUpdating}
            />
          </div>
        </CardSection>
      </div>
    </div>
  )
}
export default EditSynergyDescription;